import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wmrj23yq37: FaireBrandEntity = {
  token: "b_wmrj23yq37",
  type: "brand",
  name: "Wildheart Crystals",
  avatarUrl:
    "https://cdn.faire.com/fastly/afd0e46823baa2d5993b08f121532046c8fb859c6430c048d338572c0b684dd6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/392370b6d389b0492d1a13119a546fd90c2db516a8ebac5e301f0f3f46a93e39.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/afd0e46823baa2d5993b08f121532046c8fb859c6430c048d338572c0b684dd6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/392370b6d389b0492d1a13119a546fd90c2db516a8ebac5e301f0f3f46a93e39.jpeg",
  location: "Ojai, CA, USA",
  minimumOrderDollars: 104,
  rating: 4,
  reviewCount: 2,
  isInsider: true,
  description:
    "Celebrate the natural beauty and metaphysical influence of natural gemstones. This is your collection of rare zincite crystals, sapphire, aquamarine, tourmaline, opals, emeralds and other raw gems. Also a large selection of organically-styled and handcrafted sturdy wire wrap jewelry designs with precious metals like gold, rose gold and silver and raw gems in their natural untreated state at wholesale prices.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:53:05.010Z",
    importedBy: "entity-db-cli",
  },
};
